/**
 * Money formatting helpers for street-legal billing UI.
 * Backend stores everything in cents; never let cents leak into the
 * UI display, and never accept floats in the network layer.
 *
 * iter 370hc.
 */

/** Format an integer cents amount → "$395.00" (or "—" when null). */
export function formatCents(cents) {
  if (cents == null || cents === "") return "—";
  const n = Number(cents);
  if (!Number.isFinite(n)) return "—";
  return `$${(n / 100).toFixed(2)}`;
}

/** Parse a free-form dollar string → integer cents. Returns null on
 *  invalid input so callers can show a validation error. Accepts:
 *    "395", "395.00", "$395.00", "395.5"
 */
export function parseCents(input) {
  if (input == null) return null;
  const stripped = String(input).replace(/[$,\s]/g, "").trim();
  if (stripped === "") return null;
  const n = Number(stripped);
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.round(n * 100);
}

/** Dollar input value formatter — for an `<input type="number">`
 *  pre-fill. Returns a numeric string like "395.00" or "" when null.
 */
export function centsToInputValue(cents) {
  if (cents == null || cents === "") return "";
  const n = Number(cents);
  if (!Number.isFinite(n)) return "";
  return (n / 100).toFixed(2);
}

/** Walk-in sales tax: 7% of the cart's sale price, rounded to the
 *  nearest $5 (500 cents). Input + output are integer cents.
 *  iter 452 — Jake's equation for retail LSV conversions.
 */
export function walkInSalesTaxCents(cartCostCents) {
  const n = Number(cartCostCents);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.round((n * 0.07) / 500) * 500;
}
